<template>
  <van-popup @opened="calculationAllHeight" :close-on-click-overlay="false" @click-overlay="close" v-model="value" style="height: calc(100% - 128px)" round position="bottom">
    <div class="addTags">
      <div class="components" v-show="loading">
        <van-loading  color="#18cc9f" >加载中...</van-loading>
      </div>
      <div style="width: 100%;" ref="headers">
        <div class="block" @click="close"/>
        <div class="header">
          <h2>添加标签</h2>
          <button @click="close">完成</button>
        </div>
        <div class="search">
          <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/search-grey.svg" />
          <input v-model="search" placeholder="添加标签可以获得更多互动哦" />
          <img v-if="search" style="margin-right: 0;width: 20px;height: 20px;" @click="search = ''" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/close-grey.svg"/>
        </div>
        <h4 class="selected" v-if="checkedTags.length">已选标签</h4>
        <div class="select-tab-box">
          <span class="tag-item" v-for="(tag, index) of checkedTags" :key="tag.id">
            <span class="tag-desc"># {{tag.title}}</span>
            <img
              @click="removeSelectTag(index)"
              src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/tag-close.svg"
            />
          </span>
        </div>
      </div>
      <van-tabs v-if="!search" v-model="activeName" color="#18CC9F"  title-active-color="#18CC9F" title-inactive-color="#ccc">
        <van-tab title-style="font-size: 15px" title="推荐" name="recommend">
          <div class="tab-box" :style="{ height: maxHeight }">
            <div class="tab-box-item" v-for="item of recommendTag" :key="item.id" @click="checkeTag(item)">
              <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%23-grey.svg"/>
              <div class="info">
                <span>{{ item.title }}</span>
                <span class="total">{{ item.id ? (`${item.tagCount}条动态`) : '点击添加新标签'}}</span>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title-style="font-size: 15px" title="历史" name="history">
          <div class="tab-box" :style="{ height: maxHeight }">
            <div class="tab-box-item" v-for="item of historyTag" :key="item.id" @click="checkeTag(item)">
              <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%23-grey.svg"/>
              <div class="info">
                <span>{{ item.title }}</span>
                <span class="total">{{ item.id ? (`${item.tagCount}条动态`) : '点击添加新标签'}}</span>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <div v-else class="tab-box" ref="searchHeight" :style="{ height: maxSearchHeight }">
        <div class="tab-box-item" v-for="item of searchTag" :key="`search${item.id}`" @click="checkeTag(item)">
          <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%23-grey.svg"/>
          <div class="info">
            <span>{{ item.title }}</span>
            <span class="total">{{ item.id ? (`${item.tagCount}条动态`) : '点击添加新标签'}}</span>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import { Popup, Tab, Tabs, Toast, Loading } from 'vant'
import { get } from '../utils/request'
import { get as getCookies } from '../utils/token.js'
export default {
  name: 'add-tag',
  model: {
    prop: 'value',
    event: 'close'
  },
  props: {
    value: Boolean,
    oldTags: {
      type: Array,
      default: () => []
    }
  },
  components: {
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Loading.name]: Loading
  },
  data () {
    return {
      activeName: 'recommend',
      loading: true,
      search: '',
      checkedTags: [],
      recommendTag: [],
      historyTag: [],
      searchTag: [],
      maxHeight: 'none',
      maxSearchHeight: 0
    }
  },
  mounted () {
    this.getTags({
      tagType: 1
    }, list => {
      this.recommendTag = list
    })
  },
  methods: {
    calculationAllHeight () {
      this.calculationHeight()
      this.calculationSearchHeight()
    },
    calculationHeight () {
      this.$nextTick(() => {
        const height = this.$refs.headers.clientHeight
        this.maxHeight = `${window.innerHeight - (height + 44 + 128 + 16 * 2 + 30)}px`
      })
    },
    /**
     * 动态计算输入出现的tab的最大高度
     */
    calculationSearchHeight () {
      // const height = this.$refs.searchHeight.clientHeight
      // this.maxSearchHeight = `${window.innerHeight - (height + 128 + 16 * 2 + 30)}px`
      this.$nextTick(() => {
        const height = this.$refs.headers.clientHeight
        this.maxSearchHeight = `${window.innerHeight - (height + 128 + 16 * 2 + 30)}px`
      })
    },
    /**
     * 查询tag
     * tagType 必须     tagType: 0 搜索， 1：推荐 2：历史
     * tagName 不是必填  tagType=0或1时必填
     * userId  不是必填  tagType=2时，必填
     */
    getTags (params = {
      tagType: 1
    }, callback) {
      this.loading = true
      const promise = get({
        url: '/circle/tag',
        params
      })
      return promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          // this.tags = detail
          if (callback) {
            callback(detail)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    close () {
      this.submit()
      this.$emit('close', false)
      this.$emit('checked', this.checkedTags)
      this.checkedTags = []
    },
    submit () {
    },
    checkeTag (tag) {
      const { checkedTags } = this
      const some = checkedTags.some(item => item.title === tag.title)
      if (some) return
      if (checkedTags.size > 4) {
        Toast('最多选择五条！')
        return
      }
      this.checkedTags.push(tag)
      this.calculationHeight()
    },
    removeSelectTag (index) {
      this.checkedTags.splice(index, 1)
    }
  },
  watch: {
    oldTags (val) {
      if (!this.value) return
      this.checkedTags = [...val, ...this.checkedTags]
    },
    value (value) {
      if (value) {
        this.checkedTags = [...this.oldTags, ...this.checkedTags]
      }
    },
    async search (value) {
      if (!value) return
      await this.getTags({
        tagType: 0,
        tagName: value
      }, list => {
        this.searchTag = list
      })
      // const { searchTag } = this
      // const some = searchTag.some(item => item.title === value)
      // if (!some) {
      //   this.searchTag.unshift({
      //     title: value,
      //     id: 'addTag'
      //   })
      // }
    },
    activeName (value) {
      const params = {
        tagType: 1
      }
      if (value === 'history') {
        params.tagType = 2
        const user = getCookies('user')
        params.userId = user.id
      }
      this.getTags(params, list => {
        this[`${value}Tag`] = list
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.addTags {
  width: 100%;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  overflow: hidden;
  .block {
    width: 30px;
    height: 5px;
    background: #d8d8d8;
    border-radius: 3px;
    margin: 0 auto;
  }
  .header {
    display: flex;
    justify-content: space-between;
    width: calc(50% + 34px);
    margin-left: calc(50% - 34px);
    margin-top: 12px;
    h2 {
      font-size: 17px;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
    }
    button {
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #18cc9f;
      line-height: 24px;
      border: none;
      outline: none;
      background: #fff;
    }
  }
  .search {
    width: 100%;
    height: 44px;
    background: #f5f5f5;
    border-radius: 25px;
    padding: 10px 16px;
    box-sizing: border-box;
    margin-top: 21px;
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
      display: inline-block;
      margin-right: 16px;
    }
    input {
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      border: none;
      outline: none;
    }
  }
  .selected {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    margin-top: 16px;
  }
  .select-tab-box {
    margin-top: 12px;
  }
}
.tag-item {
  display: inline-flex;
  // justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
  background: rgba(245, 245, 245, 1);
  border-radius: 4px;
  margin-right: 12px;
  border-radius: 16px;
  border: 1px solid #cccccc;
  padding: 6px 12px;
  box-sizing: border-box;
  margin-bottom: 8px;
  background: #fff;
  .tag-desc {
    display: inline-block;
    white-space: nowrap;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  img {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin-left: 8px;
  }
}
.tab-box {
  width: 100%;
  padding: 16px 0;
  overflow-y: scroll;
  // height: calc(100% - 16px - 5px - 24px - 12px - 44px - 21px - 21px - 16px - 42px - 12px - 44px);
  .tab-box-item {
    width: 100%;
     padding: 16px 8px;
    height: 53px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #F5F5F5;
    img {
      width: 12px;
      height: 12px;
      display: inline-block;
      margin-right: 12px;
    }
    .info {
      display: flex;
      flex-direction: column;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      .total {
        font-size: 12px;
        color: #ccc;
      }
    }
  }
}
.components {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
// /deep/ .van-tabs .van-tabs--line .van-tabs__line {
//   width: 20px;
// }

</style>
